import {
  CardGalleryBodyStatus,
  CardGalleryBodyStatusIcon,
  CardGalleryBodyStatusText,
} from "./styled";

export default function CardApproved({ approved }) {
  const message = approved
    ? "Aprovado"
    : approved === false
    ? "Recusado"
    : "Aguardando aprovação";

  const icon = approved
    ? "approved"
    : approved === false
    ? "refused"
    : "pending";

  const textColor = approved ? "green" : approved === false ? "red" : "yellow";
  return (
    <>
      <CardGalleryBodyStatus isSuccess={approved}>
        <>
          <CardGalleryBodyStatusIcon icon={icon} />
          <CardGalleryBodyStatusText color={textColor}>
            {message}
          </CardGalleryBodyStatusText>
        </>
      </CardGalleryBodyStatus>
    </>
  );
}
